<template>
    <v-card class="ma-3 pa-5">
        <div class="csvContainer">
            <v-btn color="primary" small @click="downloadRecommendationsCSV">
                Download CSV
            </v-btn>
        </div>
        <v-data-table
            :footer-props="footerProps"
            :expanded.sync="expanded"
            :headers="headers"
            :item-key="tData.id"
            :items="tData"
            :items-per-page="20"
            :loading="loading"
            :options.sync="options"
            :single-expand="singleExpand"
            class="elevation-1 "
            show-expand
        >
            <template v-slot:item.index="{ item }">
                <v-textarea
                    v-model="item.index"
                    auto-grow
                    class="ma-0 pa-0"
                    flat
                    hide-details
                    row-height="15"
                    rows="1"
                    solo
                ></v-textarea>
            </template>
            <template v-slot:item.type="{ item }">
                <v-select v-model="item.type" :items="typeOptions" />
            </template>
            <template v-slot:item.graphs="{ item }">
                <v-select
                    v-model="item.graphs"
                    :items="availableGraphs"
                    hint="Select graphs"
                    multiple
                    item-text="title"
                    hide-details
                    small-chips
                    return-object
                />
            </template>
            <template v-slot:item.locale.et.text="{ item }">
                <v-textarea
                    v-model="item.locale.et.text"
                    auto-grow
                    class="ma-0 pa-0"
                    flat
                    hide-details
                    row-height="15"
                    rows="1"
                    solo
                ></v-textarea>
            </template>
            <template v-slot:item.locale.et.disclaimer="{ item }">
                <v-textarea
                    v-model="item.locale.et.disclaimer"
                    auto-grow
                    class="ma-0 pa-0"
                    flat
                    hide-details
                    row-height="15"
                    rows="1"
                    solo
                ></v-textarea>
            </template>
            <template v-slot:item.locale.et.info_label="{ item }">
                <v-textarea
                    v-model="item.locale.et.info_label"
                    auto-grow
                    class="ma-0 pa-0"
                    flat
                    hide-details
                    row-height="15"
                    rows="1"
                    solo
                ></v-textarea>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon class="mr-2" @click="editItem(item)">
                    mdi-content-save-outline
                </v-icon>
                <v-icon class="mr-2" @click="deleteItem(item)">
                    mdi-trash-can-outline
                </v-icon>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" class="simple-table">
                    <v-simple-table>
                        <tbody style="background-color: #EEEE">
                            <tr>
                                <td class="locale">EN</td>
                                <td>
                                    <v-textarea
                                        v-model="item.locale.en.text"
                                        auto-grow
                                        class="ma-0 pa-0"
                                        dense
                                        flat
                                        hide-details
                                        placeholder="Text en"
                                        row-height="15"
                                        rows="1"
                                        solo
                                    ></v-textarea>
                                </td>
                                <!--            <td style="width:15%">
                                          <v-textarea rows="1" flat solo class="ma-0 pa-0" hide-details
                                                      row-height="15" auto-grow v-model="item.locale.en.disclaimer"></v-textarea>
                                        </td>-->
                                <td>
                                    <v-textarea
                                        v-model="item.locale.en.info_label"
                                        auto-grow
                                        class="ma-0 pa-0"
                                        dense
                                        flat
                                        hide-details
                                        placeholder="Info label en"
                                        row-height="15"
                                        rows="1"
                                        solo
                                    ></v-textarea>
                                </td>
                            </tr>
                        </tbody>
                        <tbody style="background-color: #EEEE">
                            <tr>
                                <td class="locale">FI</td>
                                <td>
                                    <v-textarea
                                        v-model="item.locale.fi.text"
                                        auto-grow
                                        class="ma-0 pa-0"
                                        dense
                                        flat
                                        hide-details
                                        placeholder="Text fi"
                                        row-height="15"
                                        rows="1"
                                        solo
                                    ></v-textarea>
                                </td>
                                <!--            <td>
                                          <v-textarea rows="1" flat solo class="ma-0 pa-0" hide-details
                                                      row-height="15" auto-grow v-model="item.locale.fi.disclaimer"></v-textarea>
                                        </td>-->
                                <td style="width:50%">
                                    <v-textarea
                                        v-model="item.locale.fi.info_label"
                                        auto-grow
                                        class="ma-0 pa-0"
                                        dense
                                        flat
                                        hide-details
                                        placeholder="Info label fi"
                                        row-height="15"
                                        rows="1"
                                        solo
                                    ></v-textarea>
                                </td>
                            </tr>
                        </tbody>
                        <tbody style="background-color: #EEEE">
                            <tr>
                                <td class="locale">LT</td>
                                <td>
                                    <v-textarea
                                        v-model="item.locale.lt.text"
                                        auto-grow
                                        class="ma-0 pa-0"
                                        dense
                                        flat
                                        hide-details
                                        placeholder="Text lt"
                                        row-height="15"
                                        rows="1"
                                        solo
                                    ></v-textarea>
                                </td>
                                <!--            <td>
                                          <v-textarea rows="1" flat solo class="ma-0 pa-0" hide-details
                                                      row-height="15" auto-grow v-model="item.locale.fi.disclaimer"></v-textarea>
                                        </td>-->
                                <td style="width:50%">
                                    <v-textarea
                                        v-model="item.locale.lt.info_label"
                                        auto-grow
                                        class="ma-0 pa-0"
                                        dense
                                        flat
                                        hide-details
                                        placeholder="Info label lt"
                                        row-height="15"
                                        rows="1"
                                        solo
                                    ></v-textarea>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </td>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import RecTableService from '@/service/RecTableService'

export default {
    name: 'RecommendationListTable',
    data() {
        return {
            footerProps: { 'items-per-page-options': [20, 50, 100] },
            tableDataSize: 0,
            expanded: [],
            singleExpand: false,
            tData: [],
            loading: false,
            options: {},
            headers: [
                { text: 'Index', value: 'index', align: 'start', sortable: false, width: '8%' },
                { text: 'Type', value: 'type', align: 'start', sortable: false, width: '15%' },
                { text: 'Graphs', value: 'graphs', align: 'start', sortable: false, width: '15%' },
                { text: '', value: 'data-table-expand', align: 'start', width: '2%' },
                { text: 'Text ET', value: 'locale.et.text', sortable: false, align: 'start', width: '30%' },
                { text: 'Info label ET', value: 'locale.et.info_label', sortable: false, align: 'start', width: '30%' },
                { text: '', value: 'actions', sortable: false, width: '10%' },
            ],
            typeOptions: ['suggestion', 'info', 'warning'],
        }
    },
    watch: {
        options: {
            async handler() {
                this.loading = true
                await this.fetchRecTableData()
                this.loading = false
            },
            deep: true,
        },
        tableData: function() {
            this.tData = this.tableData
        },
    },

    async mounted() {
        await this.fetchGraphs()
    },
    methods: {
        ...mapActions('rec', ['fetchRecTableData', 'editRec', 'deleteRec']),
        ...mapActions('graph', ['fetchGraphs']),
        async editItem(item) {
            const recommendationData = JSON.parse(JSON.stringify(item))
            this.formatGraphs(recommendationData)
            await this.editRec(recommendationData)
        },
        async deleteItem(item) {
            if (confirm('Are you sure?')) {
                await this.deleteRec(item.id)
            }
        },
        formatGraphs(item) {
            item.graphs = this.availableGraphs.map(g => {
                const graph = item.graphs?.find(itemGraph => itemGraph.id === g.id)
                if (!graph) return { id: g.id, selected: false }
                return { id: g.id, selected: true }
            })
        },
        async downloadRecommendationsCSV() {
            const resp = await RecTableService.downloadRecommendationsCSV()
            const url = window.URL.createObjectURL(new Blob([resp.data]))

            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'recommendation_table_data.csv')
            document.body.appendChild(link)
            link.click()
        },
    },
    computed: {
        ...mapState('rec', ['tableData']),
        ...mapState('graph', ['graphs']),
        availableGraphs() {
            return this.graphs
        },
    },
}
</script>

<style scoped>
.simple-table {
    padding: 0 !important;
}

.locale {
    padding-left: 1.7rem !important;
    width: 170px !important;
}

.csvContainer {
    display: flex;
    align-items: center;
    justify-content: end;
    padding: 15px 0;
}
</style>
